import { render, staticRenderFns } from "./crudInstancesSystem.vue?vue&type=template&id=527a13dc&scoped=true&"
import script from "./crudInstancesSystem.vue?vue&type=script&lang=js&"
export * from "./crudInstancesSystem.vue?vue&type=script&lang=js&"
import style0 from "./crudInstancesSystem.vue?vue&type=style&index=0&id=527a13dc&prod&lang=css&"
import style1 from "./crudInstancesSystem.vue?vue&type=style&index=1&id=527a13dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527a13dc",
  null
  
)

export default component.exports